import React, { FC } from 'react';
import { Trash, Plus } from '@phosphor-icons/react';
import { FormStepNode } from '../workoutBuilderTypes';
import StepSingleRow from './StepSingleRow';
import StepRecoveryField from './StepRecoveryField';
import styles from './ConditioningSteps.module.scss';

interface StepGroupCardProps {
  node: FormStepNode;
  onChange: (patch: Partial<FormStepNode>) => void;
  onRemove: () => void;
  onAddChild: () => void;
  onRemoveChild: (childId: string) => void;
  onUpdateChild: (childId: string, patch: Partial<FormStepNode>) => void;
  previewAthleteId?: string;
}

const StepGroupCard: FC<StepGroupCardProps> = ({
  node,
  onChange,
  onRemove,
  onAddChild,
  onRemoveChild,
  onUpdateChild,
  previewAthleteId,
}) => {
  return (
    <div className={styles.groupCard}>
      <div className={styles.groupCardHeader}>
        <span className={styles.groupRepeatLabel}>Ripeti ×</span>
        <input
          type="number"
          className={styles.compactInput}
          placeholder="6"
          value={node.repeat}
          min={1}
          onChange={(e) => onChange({ repeat: e.target.value })}
          style={{ maxWidth: 60 }}
        />
        <button
          type="button"
          className={styles.removeBtn}
          onClick={onRemove}
          title="Rimuovi gruppo"
        >
          <Trash size={14} />
        </button>
      </div>

      <div className={styles.groupChildrenList}>
        {node.children.map((child) => (
          <StepSingleRow
            key={child._localId}
            node={child}
            compact
            previewAthleteId={previewAthleteId}
            onChange={(patch) => onUpdateChild(child._localId, patch)}
            onRemove={() => onRemoveChild(child._localId)}
          />
        ))}
      </div>

      <button
        type="button"
        className={styles.addChildBtn}
        onClick={onAddChild}
      >
        <Plus size={13} weight="bold" />
        <span>Aggiungi tratto</span>
      </button>

      <div className={styles.groupSetRecovery}>
        <StepRecoveryField
          value={node.setRecovery}
          previewAthleteId={previewAthleteId}
          onChange={(setRecovery) => onChange({ setRecovery })}
          label="Recupero tra serie"
        />
      </div>
    </div>
  );
};

export default StepGroupCard;
